// A positive guard for the "real dashboard" slide type. Needed because
// WeatherBoardType ({ id, name }) is a structural supertype of the other slide
// types, so narrowing via `!isWeatherBoard(...)` collapses to `never`. Checking
// for the dashboard's `canvas` narrows correctly instead.
const isDashboardSlide = (
  slide: DashboardType | WeatherBoardType | DriverLeaderboardSlide,
): slide is DashboardType => {
  // @ts-ignore - only DashboardType has a canvas
  return !!slide.canvas;
};

export default isDashboardSlide;
